import { IS_MOBILE } from '@constants/global';

const getMobileQualitySetting = () => {
  if (!IS_MOBILE()) return 1;

  // Check device capabilities
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl2') || canvas.getContext('webgl');

  if (!gl) return 2; // Fallback for very old devices

  // Get device info
  const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
  const renderer = debugInfo
    ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
    : '';
  const vendor = debugInfo
    ? gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL)
    : '';

  // Memory detection
  const memory = navigator.deviceMemory || 4; // Default to 4GB if unknown
  const cores = navigator.hardwareConcurrency || 4;

  // Progressive quality based on device capabilities
  if (
    memory <= 2 ||
    cores <= 4 ||
    renderer.includes('Mali-') ||
    renderer.includes('Adreno 3')
  ) {
    return 2.5; // Low-end mobile
  } else if (
    memory <= 4 ||
    renderer.includes('Adreno 4') ||
    renderer.includes('PowerVR')
  ) {
    return 2; // Mid-range mobile
  } else if (IS_MOBILE()) {
    return 1.5; // High-end mobile app
  } else {
    return 1.8; // High-end mobile browser
  }
};
const qualitySetting = getMobileQualitySetting();
const isMobileLowMemory = () => {
  return IS_MOBILE() && (navigator.deviceMemory <= 2 || qualitySetting >= 2.5);
};

const fpsLimit = IS_MOBILE() ? 30 : 120;

const debugMobileConfig = () => {
  const isMobile = IS_MOBILE();
  const qualitySetting = qualitySetting;
  const isLowMemory = isMobileLowMemory();

  const debugInfo = {
    platform: isMobile ? 'MOBILE' : 'DESKTOP',
    qualitySetting: qualitySetting,
    fpsLimit: this.fpsLimit,
    isLowMemory: isLowMemory,
    deviceInfo: {
      userAgent: navigator.userAgent,
      memory: navigator.deviceMemory || 'unknown',
      cores: navigator.hardwareConcurrency || 'unknown',
      screenSize: `${window.innerWidth}x${window.innerHeight}`,
      pixelRatio: window.devicePixelRatio,
      touchSupport: 'ontouchstart' in window,
    },
  };

  // Get WebGL info for debugging
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl2') || canvas.getContext('webgl');
  if (gl) {
    const debugRendererInfo = gl.getExtension('WEBGL_debug_renderer_info');
    debugInfo.webgl = {
      renderer: debugRendererInfo
        ? gl.getParameter(debugRendererInfo.UNMASKED_RENDERER_WEBGL)
        : 'unknown',
      vendor: debugRendererInfo
        ? gl.getParameter(debugRendererInfo.UNMASKED_VENDOR_WEBGL)
        : 'unknown',
      version: gl.getParameter(gl.VERSION),
      extensions: gl.getSupportedExtensions()?.slice(0, 10) || [], // First 10 extensions
    };
  }

  // I WILL KEEP THIS HERE FOR DEBUGGING PURPOSES IF THIS DOES NOT SOLVE IOS ISSUES
  // console.group('🚀 CAD Viewer Mobile Config Debug');
  // console.log('📱 Platform:', debugInfo.platform);
  // console.log('⚙️ Quality Setting:', qualitySetting, isMobile ? '(Mobile optimized)' : '(Desktop)');
  // console.log('🎯 FPS Limit:', this.fpsLimit);
  // console.log('💾 Low Memory Mode:', isLowMemory ? 'YES' : 'NO');
  // console.log('📊 Device Info:', debugInfo.deviceInfo);
  // if (debugInfo.webgl) {
  //   console.log('🎮 WebGL Info:', debugInfo.webgl);
  // }
  // console.groupEnd();

  // Store debug info for potential UI display

  return debugInfo;
};

const blockPinchZoom = () => {
  if (!IS_MOBILE()) return;
  // Prevent pinch-zoom and double-tap zoom on iOS
  document.addEventListener(
    'touchmove',
    function (event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    },
    { passive: false },
  );

  let lastTouchEnd = 0;
  document.addEventListener(
    'touchend',
    function (event) {
      const now = new Date().getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    false,
  );

  window.addEventListener(
    'gesturestart',
    function (e) {
      e.preventDefault();
      document.body.style.zoom = 1;
    },
    { passive: false },
  );

  window.addEventListener(
    'gesturechange',
    function (e) {
      e.preventDefault();
      document.body.style.zoom = 1;
    },
    { passive: false },
  );

  window.addEventListener(
    'gestureend',
    function (e) {
      e.preventDefault();
      document.body.style.zoom = 1;
    },
    { passive: false },
  );
};

// Call debug on initialization
// debugMobileConfig();

export { fpsLimit, isMobileLowMemory, qualitySetting, blockPinchZoom };
